<template>
  <NewsHero />
  <VideosSection />
  <TourOperators />
  <HolyPlaces />
  <HajjMission />
  <Faq />
  <OurPartners />

  <MobileApps />
</template>

<script>
import { defineComponent } from "vue";
import NewsHero from "@/components/NewsHero.vue";
import VideosSection from "@/components/VideosSection.vue";
import TourOperators from "@/components/TourOperators.vue";
import HolyPlaces from "@/components/HolyPlaces.vue";
import HajjMission from "@/components/HajjMission.vue";
import Faq from "@/components/Faq.vue";
import OurPartners from "@/components/OurPartners.vue";
import MobileApps from "@/components/MobileApps.vue";
export default defineComponent({
  name: "HomeView",
  components: {
    NewsHero,
    VideosSection,
    TourOperators,
    HolyPlaces,
    HajjMission,
    Faq,
    OurPartners,
    MobileApps,
  },
});
</script>
